import EventsSerializer from './base';

export default class EventCount extends EventsSerializer {
  normalize(modelClass, payload) {
    let defaults = {
      currentAttendees: 0,
    };
    Object.assign(defaults, payload);
    Object.assign(payload, defaults);
    return super.normalize(...arguments);
  }
}
